<template lang="pug">
  section
    .hero.is-light
      .hero-body
        h1.title.is-5
          span.icon
            i.fas.fa-book.fa-sm.fa-fw
          span
            | 書籍情報
    section.section
      .table-border
        b-table(
          class="table is-fullwidth is-hoverable is-bordered is-narrow"
          :data="data"
          :loading="loading"
          hoverable)
          template(slot-scope="props")
            b-table-column(field="id" label="Id" width="80")
              | {{ props.row.id }}
            b-table-column(field="product_code" label="商品コード" width="90")
              | {{ props.row.product_code }}
            b-table-column(field="isbn" label="ISBN" width="130")
              | {{ props.row.isbn }}
            b-table-column(field="book_stock_status_id" label="在庫ステータス" width="50")
              b-select(
                v-model="props.row.book_stock_status_id"
                @input="submit(props.row.id, props.row.book_stock_status_id)"
              )
                option(
                  v-for="status in book_stock_statuses"
                  :value="status.id"
                  :key="status.id"
                )
                  | {{ status.name }}
            b-table-column(field="name" label="タイトル" width="400")
              | {{ props.row.name }}
            b-table-column(field="released_on" label="発売日" width="130")
              | {{ props.row.released_on }}
            b-table-column(field="selling_price" label="販売価格" width="100")
              | {{ formatNumber(props.row.selling_price) }}
            b-table-column(field="ohmura_stock" label="大村在庫" width="100")
              | {{ formatNumber(props.row.ohmura_stock) }}
            b-table-column(field="ohmura_returned_stock" label="大村返品在庫" width="100")
              | {{ formatNumber(props.row.ohmura_returned_stock) }}
            b-table-column(field="bookbindary_stock" label="製本所" width="100")
              | {{ formatNumber(props.row.bookbindary_stock) }}
            b-table-column(field="usable_stock" label="使える在庫" width="100")
              | {{ formatNumber(props.row.usable_stock) }}

</template>

<script>
  export default {
    name: 'book-list-table',
    data() {
      return {
        data: [],
        book_stock_statuses: [],
        loading: false
      }
    },
    methods: {
      submitRequest(id, value){
        var method = 'put'
        var url = `/api/v1/books/${id}.json`
        var params = {
          book: {
            book_stock_status_id: value
          }
        }
        return this.$http({ method: method, url: url, data: params })
      },
      submit(id, value){
        this.loading = true
        this.submitRequest(id, value).then(({data}) => {
          if(data.book.errors) {
            this.errors.clear()
            this.loading = false
            this.$toast.open({
              message: '更新に失敗しました。',
              type: 'is-danger',
              position: 'is-bottom'
            })
            return
          }
          this.loading = false
          this.$toast.open({
            message: '更新に成功しました。',
            type: 'is-danger',
            position: 'is-bottom'
          })
        })
        .catch((error) => {
          this.loading = false
          throw error
        })
      },
      loadAsyncData() {
        this.loading = true
        this.$http.get(`/api/v1/books?mode=order`)
            .then(({data}) => {
              this.data = []
              data.books.forEach((item) => {
                this.data.push(item)
              })
              this.loading = false
            })
            .catch((error) => {
              this.data = []
              this.total = 0
              this.loading = false
              throw error
            })
        this.$http.get('/api/v1/book_stock_statuses')
            .then(({data}) => {
              data.book_stock_statuses.forEach((status) => {
                this.book_stock_statuses.push(status)
              })
              this.loading = false
            })
            .catch((error) => {
              this.book_stock_statuses = []
              this.loading = false
              throw error
            })
      },
      formatNumber(number) {
        if(!number)
         return ""
        return number.toLocaleString()
      },
      changeSelectColor() {
        document.querySelectorAll('select').forEach((select) => {
          // 在庫ありのものをグレーにする
          if(select.value == '0') {
            select.classList.add('has-text-white')
          } else {
            select.classList.remove('has-text-white')
          }
        })
      }
    },
    mounted() {
      this.loadAsyncData()
    },
    updated() {
      this.changeSelectColor()
    }
  }
</script>